import { useState } from 'react';
import { UsersTable } from './UsersTable';
import { ManageUser } from './ManageUsers';

export const UsersComponent = () => {
  const [modalOn, setModalOn] = useState(false);
  return (
    <>
      {modalOn && <ManageUser setModalOn={setModalOn}></ManageUser>}
      <div className='simply-header margin-left-2 margin-bottom-1 margin-top-3'>
        <button onClick={() => setModalOn(true)} className='simply-header__button button-primary font-h5-medium margin-right-1'>
          New User
        </button>
        <h2 className='font-h2-medium'>Users</h2>
      </div>
      <UsersTable />
    </>
  );
};
